import React from "react";

const Orderlogs = ({ status }) => {

  const formatDate = (isoString) => {
    const options = {
      month: 'long',
      day: 'numeric',
      year:'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // Set to false if you want 24-hour format
    };
    return new Date(isoString).toLocaleDateString('en-US', options); // Convert to "Month Day"
  };


  return (
    <div className="uk-grid" uk-grid="">
      <div className="uk-width-">
        <div className=" uk-margin-top">
          <div className="uk-timeline">
            {status.slice().reverse().map((val, index) => (
              <>
                <div
                  className={
                    status.length===1 ?index === status.length - 1 ? "uk-timeline-item " : "uk-timeline-item disabled":index !== 0 ? "uk-timeline-item disabled" : "uk-timeline-item "
                  }
                  key={index}
                >
                  <div className="uk-timeline-icon">
                    <span className="uk-badge">
                      <span uk-icon="check"></span>
                    </span>
                  </div>
                  <div className="uk-timeline-content">
                    <div className="uk-card uk-card-default uk-margin-small-bottom uk-overflow-auto">
                      <div className="">
                        <div className=" uk-flex uk-flex-between">
                          <h3 className="uk-card-title">
                            <time>{formatDate(val?.date)}</time>
                          </h3>
                          <span className="uk-label uk-padding-xsmall uk-margin-auto-left">
                            {val?.status} 
                          </span>
                        </div>
                        {val?.status === 'incart'?
                        <p> Order is Pending </p>
                        :
                        val?.status === 'pending-dealership'?

                        'Order has been placed'
                        :

                        (val.remarks||'-')
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Orderlogs;
